const isDate = dateStr => {
	return Object.prototype.toString.call(dateStr) === '[object Date]';
};

export const formatDate = (date, pattern) => {
	if (!isDate(date)) {
		date = new Date(date);
	}
	const month =
		date.getMonth() > 8 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
	const day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
	const fullYear = date.getFullYear();
	let dateValue;
	switch (pattern) {
		case 'yyyy-mm-dd':
			dateValue = `${fullYear}-${month}-${day}`;
			break;
	}
	return dateValue;
};